export default "__VITE_ASSET__60cb7049__"